import styled from "styled-components";

export default styled.input.attrs({ type: "file" })`
  display: none;
`;
